module.exports = __webpack_public_path__ + "static/media/style-logo.bd3ae0db.png";